exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#sidebar-panel.chat-panel {\n  max-width: 220px; }\n\nmd-sidenav-container {\n  background-color: #eceff1;\n  background-repeat: no-repeat;\n  background-position: -webkit-calc(50% + 128px) 0;\n  background-position: -5;\n  background-position: calc(50% + 128px) 0;\n  background-size: auto 100%;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.12); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/layouts/global/global-layout.component.scss
// module id = ../../../../../src/app/layouts/global/global-layout.component.scss
// module chunks = 8